<template>
    <main>
       <div class="container-fluid">
            <div class="row">
               <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                    </div>
                      <div class="page-toolbar">
                        <div class="page-title">
                            <span class="title">Applicaton Package</span> 
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>
                        <div class="page-create-button">
                            <router-link to="/modules/workpackages/edit" class="btn-create">Create</router-link>
                        </div>
                        <div class="page-filter">
                            <input type="search" value="" placeholder="Searching..." class="form-control" v-on:click="openAction">
                            <CustomSearch v-bind:class="{ active: isActive }" @searchEvent="childMethod" @openAction="openAction"></CustomSearch>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <GenericList v-if="generic" ref="loadGeneric"></GenericList>
        <CustomList v-else ref="loadCustom"></CustomList>

    </main>
</template>



<script>
import { ref } from "vue";
import breadcrumbs from "@/views/modules/WorkPackages/MenuList.vue";
import lang from "@/views/modules/WorkPackages/language/en";
import GenericList from "@/components/layout/shared/generic/ListView.vue";
import CustomList from "@/views/modules/WorkPackages/ListView.vue";
import CustomSearch from "@/views/modules/WorkPackages/SearchView.vue";
export default {
name: "list-application-package",
components: {
    breadcrumbs,
    GenericList,
    CustomList,
    CustomSearch,
    },
    data(){
        return{
            generic: true,
            isActive:false,
            metaList:[
                {
                    label: lang.LBL_WORKPACKAGE_NAME,
                    link:true,
                    width:200,
                    moduleName:'WorkPackages',/// moduleName is required
                    routePath:'workpackages',/// routePath is required at start of object
                    isSort: true,
                    field_name: 'workpackage_name'
                },
                {
                    label: lang.LBL_WORK_PACKS_DATE,
                    link:false,
                    width:50,
                    routePath:'Opportunitys',/// routePath is required at start of object,
                    isSort: true,
                    field_name: 'workpackage_date'
                },
                {
                    label: lang.LBL_STATUS,
                    link:false,
                    width:50,
                    routePath:'',
                    isSort: true,
                    field_name: 'status'
                },
                
            ],
            columns: ['workpackage_name', 'workpackage_date', 'status'],

        }
    },
    mounted() {
        this.childMethod();
    },
    methods:{
        childMethod(search=''){
            if(this.generic == true){
                this.$refs.loadGeneric.loadGenericView(this.metaList,this.columns,search);
            }
        },
        openAction() {
            this.isActive = !this.isActive;
        }, 

    }
}

</script>



